module.exports = __webpack_public_path__ + "img/jiagoutu.7e9510fe.png";